import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-10/task-01";

const task: Slide = {
  title: "Sort capacitors in order of increasing capacity.",
  description: "Drag and drop elements in the correct order.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
